import { IState } from '../redux/reducer';
import { matchLanguage } from './resolveLanguage';

interface Metadata {
  language?: string;
  source?: string;
  tags?: {
    label: string;
  }[];
}

export const languageFromMetadata = (state: IState) => (record?: {
  metadata?: Metadata;
  latest_version?: { metadata?: Metadata };
}) => {
  const catalog = state.core.languages.list;
  if (record?.metadata?.tags) {
    for (const tag of record.metadata.tags) {
      const matched = matchLanguage(tag.label, catalog);
      if (matched) {
        return matched;
      }
    }
  }

  const stored = record?.metadata?.language || record?.latest_version?.metadata?.language;
  return stored ? matchLanguage(stored, catalog) ?? stored : stored;
};

export const sourceFromMetadata = (state: IState) => (record?: { metadata?: Metadata }) => {
  const fromTags = record?.metadata?.tags
    ?.map(t => t.label)
    .find(l => state.core.owners.list.includes(l.toLowerCase()));
  return fromTags ? fromTags : record?.metadata?.source;
};
